
import { createFeature, createReducer, on } from '@ngrx/store';

import * as actions from './shared-error-log.actions';

export interface State {
    errors: any[];
}

export const initialState: State = {
    errors: [],
};

export default createFeature({
  name: 'sharedErrorLog',
  reducer: createReducer(
    initialState,
    on(actions.reset, (state: State): State => ({
            ...state,
            errors: [],
        })),
    on(actions.add, (state: State, { error }): State => ({
            ...state,
            errors: [
                error,
                ...state.errors
            ]
        })),
  )}
);